import it from './it.json';
import en from './en.json';
import { useSettingsStore } from '../stores/settingsStore';

const translations = { it, en };

/**
 * Standalone translation function (for utils, prompts, non-React code)
 * @param {string} key - dot-separated key e.g. 'toolbar.selectionMode'
 * @param {string} [lang='en']
 * @param {Object} [vars={}] - interpolation variables e.g. { name: 'Mio Progetto' }
 * @returns {string}
 */
export function t(key, lang = 'en', vars = {}) {
  const dict = translations[lang] ?? translations.en;
  const str = key.split('.').reduce((o, k) => o?.[k], dict) ?? key;
  return Object.entries(vars).reduce((s, [k, v]) => s.replaceAll(`{{${k}}}`, v), str);
}

/**
 * React hook — returns a t() bound to the current app language
 * @returns {(key: string, vars?: Object) => string}
 */
export function useT() {
  const lang = useSettingsStore((s) => s.lang);
  return (key, vars) => t(key, lang, vars);
}
